import allInHandleWishlist from "@magalu/ecomm-components/rave/events/AllIn/handleWishlist";
import allInPageView from "@magalu/ecomm-components/rave/events/AllIn/pageView";
import { addToCartAppsFlyer } from "@magalu/ecomm-components/rave/events/AppsFlyer/addToCart";
import { addToWishListAppsFlyer } from "@magalu/ecomm-components/rave/events/AppsFlyer/addToWishlist";
import { screenViewAppsFlyer } from "@magalu/ecomm-components/rave/events/AppsFlyer/screenView";
import { cloudRetailAddToCart } from "@magalu/ecomm-components/rave/events/CloudRetail/addToCart";
import { cloudRetailView } from "@magalu/ecomm-components/rave/events/CloudRetail/viewItem";
import addToCartSuccessCookie from "@magalu/ecomm-components/rave/events/Cookies/addToCart";
import criteoPageView from "@magalu/ecomm-components/rave/events/Criteo/pageView";
import { addToCartError } from "@magalu/ecomm-components/rave/events/GA/add-to-cart";
import { brandListItemClick } from "@magalu/ecomm-components/rave/events/GA/all-brands";
import { productAttributeClick } from "@magalu/ecomm-components/rave/events/GA/attribute";
import {
  triggerCDCCardClickEvent,
  triggerCDCBottomSheetBtnClickEvent,
  triggerCDCViewContentEvent,
} from "@magalu/ecomm-components/rave/events/GA/cdc";
import { filterLinkListClick } from "@magalu/ecomm-components/rave/events/GA/filter";
import {
  luContentClick,
  luContentView,
} from "@magalu/ecomm-components/rave/events/GA/luContent";
import { clickPagination } from "@magalu/ecomm-components/rave/events/GA/pagination";
import { productLabelClick } from "@magalu/ecomm-components/rave/events/GA/product-label";
import {
  productPaymentChange,
  productPaymentClick,
} from "@magalu/ecomm-components/rave/events/GA/product-payment";
import { productViewItem } from "@magalu/ecomm-components/rave/events/GA/product-view-item";
import {
  productBenefitCardClick,
  productBenefitsRefundLinkClick,
  productBenefitsView,
} from "@magalu/ecomm-components/rave/events/GA/productBenefit";
import {
  questionClickConfirmQuestion,
  questionClickOpenConfirm,
  questionFeedbackResponseError,
  questionFormSeeMore,
  questionListImpression,
} from "@magalu/ecomm-components/rave/events/GA/questions";
import {
  reviewPdpClick,
  reviewSeeMoreClick,
} from "@magalu/ecomm-components/rave/events/GA/review";
import {
  searchClear,
  searchClose,
  searchSubmit,
} from "@magalu/ecomm-components/rave/events/GA/search";
import {
  sellerInfoPdpLinkClick,
  sellerScoreCalcInfoClick,
  sellerScoreImpression,
} from "@magalu/ecomm-components/rave/events/GA/seller";
import { showcaseItemClick } from "@magalu/ecomm-components/rave/events/GA/showcase-item-click";
import { showcaseItemView } from "@magalu/ecomm-components/rave/events/GA/showcase-item-view";
import {
  zipCodeClick,
  zipCodeResponseError,
  zipCodeResponseSuccess,
} from "@magalu/ecomm-components/rave/events/GA/zipCode";
import { addToCart } from "@magalu/ecomm-components/rave/events/GA4/addToCart";
import { addToWishList } from "@magalu/ecomm-components/rave/events/GA4/addToWishList";
import {
  buyBoxAddToCart,
  seeMoreOffers,
} from "@magalu/ecomm-components/rave/events/GA4/buyBox";
import { calculateTaxes } from "@magalu/ecomm-components/rave/events/GA4/calculateTaxes";
import { chatSellerSelectContent } from "@magalu/ecomm-components/rave/events/GA4/chatSeller";
import { closenessActionContent } from "@magalu/ecomm-components/rave/events/GA4/closenessActionContent";
import {
  couponSelectContent,
  couponViewContent,
} from "@magalu/ecomm-components/rave/events/GA4/coupon";
import { followSellerSelectContent } from "@magalu/ecomm-components/rave/events/GA4/followSeller";
import { customScreenView } from "@magalu/ecomm-components/rave/events/GA4/mobile/custom-screen-view";
import { productDetailView } from "@magalu/ecomm-components/rave/events/GA4/productDetailView";
import {
  productDisplayClick,
  productDisplayView,
} from "@magalu/ecomm-components/rave/events/GA4/productRating";
import {
  productSellerChat,
  productSellerClick,
} from "@magalu/ecomm-components/rave/events/GA4/productSeller";
import {
  reviewSelectBackToHome,
  reviewSelectContent,
  reviewSendContent,
} from "@magalu/ecomm-components/rave/events/GA4/review";
import { selectItem } from "@magalu/ecomm-components/rave/events/GA4/selectItem";
import { shareClick } from "@magalu/ecomm-components/rave/events/GA4/share";
import { shippingGA4 } from "@magalu/ecomm-components/rave/events/GA4/shipping";
import { shippingResponseErrorGA4 } from "@magalu/ecomm-components/rave/events/GA4/shippingResponseErrorGA4";
import { shippingView } from "@magalu/ecomm-components/rave/events/GA4/shippingView";
import { showcaseLoadMoreSelectContent } from "@magalu/ecomm-components/rave/events/GA4/showcaseLoadMoreSelectContent";
import { viewItem } from "@magalu/ecomm-components/rave/events/GA4/viewItem";
import { viewItemList } from "@magalu/ecomm-components/rave/events/GA4/viewItemList";
import {
  clickSizeChart,
  clickVirtualFittingRoom,
  showVirtualFittingRoom,
} from "@magalu/ecomm-components/rave/events/GA4/virtualFittingRoom";
import { addToCartInsider } from "@magalu/ecomm-components/rave/events/Insider/addToCart";
import { addToWishListInsider } from "@magalu/ecomm-components/rave/events/Insider/addToWishList";
import { consumedContentInsider } from "@magalu/ecomm-components/rave/events/Insider/consumedContent";
import { itemClickInsider } from "@magalu/ecomm-components/rave/events/Insider/itemClick";
import { screenViewInsider } from "@magalu/ecomm-components/rave/events/Insider/screenView";
import { shareProductInsider } from "@magalu/ecomm-components/rave/events/Insider/shareProduct";
import rtbhAddToCart from "@magalu/ecomm-components/rave/events/RTBHouse/add-to-cart";
import rtbhAddToWishList from "@magalu/ecomm-components/rave/events/RTBHouse/add-to-wish-list";
import rtbhPageView from "@magalu/ecomm-components/rave/events/RTBHouse/page-view";
import spotifyAddToCart from "@magalu/ecomm-components/rave/events/SpotifyAdAnalytics/add-to-cart";
import spotifyAddToWishList from "@magalu/ecomm-components/rave/events/SpotifyAdAnalytics/add-to-wish-list";
import spotifyPageView from "@magalu/ecomm-components/rave/events/SpotifyAdAnalytics/page-view";
import stewieAddToCart from "@magalu/ecomm-components/rave/events/Stewie/add-to-cart";
import stewiePageView from "@magalu/ecomm-components/rave/events/Stewie/page-view";
import stewieProductListClick from "@magalu/ecomm-components/rave/events/Stewie/product-list-click";
import tiktokAddToCart from "@magalu/ecomm-components/rave/events/TikTok/add-to-cart";
import tikTokViewItem from "@magalu/ecomm-components/rave/events/TikTok/view-item";

import { recs } from "./constants/recs";

export const config = {
  recs,
};

const events = (): Record<string, Array<unknown>> => ({
  "addtocart:error": [addToCartError],
  "addtocart:success": [
    addToCart,
    addToCartSuccessCookie,
    tiktokAddToCart,
    spotifyAddToCart,
    rtbhAddToCart,
    stewieAddToCart,
    cloudRetailAddToCart,
    addToCartAppsFlyer,
    addToCartInsider,
  ],
  "buybox:addtocart": [buyBoxAddToCart],
  "buybox:seemoreoffers": [seeMoreOffers],
  "buybox:selectItem": [selectItem],
  "buybox:viewitemlist": [viewItemList],
  "cdc:bottom-sheet-confirmation-click": [triggerCDCBottomSheetBtnClickEvent],
  "cdc:card-click": [triggerCDCCardClickEvent],
  "cdc:view-content": [triggerCDCViewContentEvent],
  "click:brandListItem": [brandListItemClick],
  "click:pagination": [clickPagination],
  "click:zipCodeBar": [zipCodeClick],
  "coupon:selectItem": [couponSelectContent],
  "coupon:viewItem": [couponViewContent],
  "listlink:click": [filterLinkListClick],
  "lucontent:vertical:item:click": [luContentClick],
  "lucontent:vertical:view": [luContentView],
  "media-gallery-modal:toggle": [consumedContentInsider],
  pageView: [
    viewItem,
    tikTokViewItem,
    customScreenView,
    allInPageView,
    criteoPageView,
    spotifyPageView,
    rtbhPageView,
    stewiePageView,
    cloudRetailView,
    screenViewAppsFlyer,
    screenViewInsider,
  ],
  "product:attribute:selected": [productAttributeClick],
  "product:benefits:refund:link:click": [productBenefitsRefundLinkClick],
  "product:benefits:tags:click": [productBenefitCardClick],
  "product:benefits:view": [productBenefitsView],
  "product:calculateTaxes": [calculateTaxes],
  "product:closenessActionContent": [closenessActionContent],
  "product:detail:view": [productDetailView],
  "product:display:click": [productDisplayClick],
  "product:display:review": [productDisplayView],
  "product:installments:click": [productPaymentClick],
  "product:item:click": [
    selectItem,
    showcaseItemClick,
    stewieProductListClick,
    itemClickInsider,
  ],
  "product:item:view": [viewItemList],
  "product:label:click": [productLabelClick],
  "product:paymentmethod:change": [productPaymentChange],
  "product:rating:click": [reviewPdpClick],
  "product:seller:chat:click": [productSellerChat],
  "product:seller:click": [productSellerClick],
  "product:share:click": [shareClick, shareProductInsider],
  "product:shipping": [shippingGA4],
  "product:shipping:details": [productViewItem],
  "product:shipping:error": [shippingResponseErrorGA4],
  "product:shipping:view": [shippingView],
  "product:showcase:see-more:click": [showcaseLoadMoreSelectContent],
  "product:sizeChart:click": [clickSizeChart],
  "product:view": [viewItemList, showcaseItemView],
  "product:virtualFittingRoom:click": [clickVirtualFittingRoom],
  "product:virtualFittingRoom:show": [showVirtualFittingRoom],
  "product:wishlist:click": [
    allInHandleWishlist,
    spotifyAddToWishList,
    rtbhAddToWishList,
    addToWishList,
    addToWishListAppsFlyer,
    addToWishListInsider,
  ],
  "productlist:click": [selectItem],
  "question-confirm:click": [questionClickConfirmQuestion],
  "question-feedback:error": [questionFeedbackResponseError],
  "question-form:see-more": [questionFormSeeMore],
  "question-list:impression": [questionListImpression],
  "question:form:submit": [questionClickOpenConfirm],
  "review:finishreview:success:backtohome": [reviewSelectBackToHome],
  "review:selectcontent:view-image": [reviewSelectContent],
  "review:selectcontent:view-video": [reviewSelectContent],
  "review:selectcontent:write-review": [reviewSelectContent],
  "review:sendcontent:send-image": [reviewSendContent],
  "review:sendcontent:send-tags": [reviewSendContent],
  "review:sendcontent:send-video": [reviewSendContent],
  "reviewpdp:button:click": [reviewSeeMoreClick],
  "search:clear": [searchClear],
  "search:close": [searchClose],
  "search:submit": [searchSubmit],
  "seller:info:impression": [sellerScoreImpression],
  "seller:info:pdp:open:modal:click": [sellerInfoPdpLinkClick],
  "seller:info:selectcontent:chatSeller:click": [chatSellerSelectContent],
  "seller:info:selectcontent:followSeller:click": [followSellerSelectContent],
  "seller:score:calc:info:click": [sellerScoreCalcInfoClick],
  "zipcodebar:response:error": [zipCodeResponseError],
  "zipcodebar:response:success": [zipCodeResponseSuccess],
});

export default events;
